module.exports = __webpack_public_path__ + "static/media/Wsparcie_sprzedazy_3_A.5380b14a.png";